"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('observer.site', function () {
    this.frameId = false; // Has to be passed
    this.init = function () {
        namespace_1.default.debug.showInfo(this.frameId + 'Starting observer.site');
        this.checkHeaderStyleTag();
        this.bindEvents();
        this.resize();
    };
    this.checkHeaderStyleTag = function () {
        if (namespace_1.default.visual[this.namespace].config.optional.calculatedStyle) {
            var tHtml = '<style id="' + namespace_1.default.visual[this.namespace].config.optional.calculatedStyle + '"></style>'; // calculated styles are always the last style-sheet (apart from calculated min-/max-font-size styles) and have to be documented for the clients accordingly
            (0, jquery_1.default)('head').append(tHtml);
        }
    };
    this.bindEvents = function () {
        window.addEventListener('resize', this.resize.bind(this));
        window.addEventListener('resize', this.inform.bind(this));
    };
    /*
        Informs every object that is interested about the site-resize, plus tells the stylefills-observer to run
    */
    this.inform = function () {
        var tEvent = jquery_1.default.Event(this.frameId + namespace_1.default.events.site.resized);
        (0, jquery_1.default)(document).triggerHandler(tEvent);
        tEvent = jquery_1.default.Event(namespace_1.default.events.stylefills.checkStyles);
        (0, jquery_1.default)(document).triggerHandler(tEvent);
    };
    /*
        This function changes the apaCalculatedStyles-Tag
    */
    this.resize = function () {
        namespace_1.default.debug.showInfo(this.frameId + ': observer.site.resize has not yet been extended. If you don\'t need it, you can ignore this.');
    };
});
